var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEmpty, keys } from "ramda";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { maybe } from "tsmonads";
import { MenuItem, Select } from "@material-ui/core";
import { WebSocketMessage } from "../../serverConnection";
import CountrySelect from "../common/CountrySelect";
import InputField from "../common/InputField";
var validate = function (device) {
    var errors = {};
    if (isEmpty(device.host)) {
        errors.host = "Must not be empty";
    }
    if (isEmpty(device.address)) {
        errors.address = "Must not be empty";
    }
    if (device.enterprise === "none") {
        errors.enterprise = "Device must be associated with an enterprise";
    }
    if (isEmpty(device.location)) {
        errors.location = "Device must have a location";
    }
    return errors;
};
var EditDevice = /** @class */ (function (_super) {
    __extends(EditDevice, _super);
    function EditDevice(props) {
        var _a, _b, _c, _d, _e, _f, _g;
        var _this = _super.call(this, props) || this;
        _this.enterpriseSelect = function (error) {
            var cu = _this.props.currentUser;
            var ents = [];
            switch (cu.role) {
                case "su":
                    ents = _this.props.enterprises.valueSeq().toArray();
                    break;
                default:
                    ents = _this.props.enterprises
                        .valueSeq()
                        .toArray()
                        .filter(function (e) { return cu.enterprises.includes(e.id); });
            }
            return (React.createElement("div", { className: "col s12 m6" },
                React.createElement("label", null, "Enterprise"),
                React.createElement(Select, { className: "select", placeholder: "Enterprise", name: "enterprise", onChange: function (e) { return _this.setState({ enterprise: e.target.value }); }, value: _this.state.enterprise },
                    React.createElement(MenuItem, { value: "none" }, "---"),
                    ents.map(function (ent) { return (React.createElement(MenuItem, { key: ent.id, value: ent.id }, ent.name)); })),
                React.createElement("div", { className: "red-text", style: { marginBottom: "20px" } }, error && error)));
        };
        _this.locationSelect = function (error) {
            var ent = _this.state.enterprise;
            var areas = maybe(_this.props.enterprises.get(ent))
                .map(function (e) { return e.areas; })
                .orElse([])
                .filter(function (a) { return a.country === _this.state.country; })
                .map(function (a) { return a.name; });
            var options = areas.map(function (a) { return (React.createElement(MenuItem, { key: a, value: a }, a)); });
            return (React.createElement("div", { className: "col s12 m6" },
                React.createElement("label", null, "Location"),
                React.createElement(Select, { className: "select", placeholder: "Location", name: "location", onChange: function (e) { return _this.setState({ location: e.target.value }); }, value: _this.state.location },
                    React.createElement(MenuItem, { value: "none" }, "---"),
                    options),
                React.createElement("div", { className: "red-text", style: { marginBottom: "20px" } }, error && error)));
        };
        _this.handleFormSubmit = function () {
            // tslint:disable-next-line: no-console
            console.error("fgkdfgdfkg");
            _this.props.send(WebSocketMessage("devices", "update", _this.state));
            _this.props.history.push("/devices");
        };
        var device = props.devices.get(props.match.params.id);
        _this.state = {
            id: device.id,
            enterprise: (_a = device.enterprise) !== null && _a !== void 0 ? _a : "none",
            environment: (_b = device.environment) !== null && _b !== void 0 ? _b : "development",
            host: (_c = device.host) !== null && _c !== void 0 ? _c : "",
            address: (_d = device.address) !== null && _d !== void 0 ? _d : "",
            location: (_e = device.location) !== null && _e !== void 0 ? _e : "none",
            position: (_f = device.position) !== null && _f !== void 0 ? _f : { lat: 0, long: 0 },
            country: (_g = device.country) !== null && _g !== void 0 ? _g : "DE",
        };
        return _this;
    }
    EditDevice.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var errors = validate(this.state);
        return (React.createElement("div", { className: "container content" },
            React.createElement("div", { className: "container" },
                React.createElement("h5", null, "Edit Device"),
                React.createElement("br", null),
                React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                    React.createElement("div", { className: "card-panel" },
                        React.createElement("div", null,
                            React.createElement("label", null, "Host"),
                            React.createElement("div", null,
                                React.createElement(InputField, { disabled: true, label: "Devie serial", type: "text", placeholder: "Serial", value: this.state.id }))),
                        React.createElement(InputField, { label: "Host", type: "text", placeholder: "Host", value: this.state.host, meta: { touched: true, error: errors.host }, onChange: function (host) { return _this.setState({ host: host }); } }),
                        React.createElement(InputField, { label: "Address", type: "text", placeholder: "Address", value: this.state.address, meta: { touched: true, error: errors.address }, onChange: function (address) { return _this.setState({ address: address }); } }),
                        this.enterpriseSelect(errors.enterprise),
                        !isEmpty(this.state.enterprise) && (React.createElement(React.Fragment, null,
                            React.createElement(CountrySelect, { value: this.state.country, onChange: function (e) { return _this.setState({ country: e.target.value }); }, enterprises: this.props.enterprises.valueSeq().toArray() }),
                            this.locationSelect(errors.location),
                            !isEmpty(this.state.location) && (React.createElement(React.Fragment, null,
                                React.createElement(InputField, { label: "Latitude", type: "number", step: "any", placeholder: "LAT", value: (_a = this.state.position) === null || _a === void 0 ? void 0 : _a.lat, meta: { touched: true, error: errors.position }, onChange: function (lat) {
                                        return _this.setState({
                                            position: __assign(__assign({}, _this.state.position), { lat: parseInt(lat, 10) }),
                                        });
                                    } }),
                                React.createElement(InputField, { label: "Longitude", type: "number", step: "any", placeholder: "LNG", value: (_b = this.state.position) === null || _b === void 0 ? void 0 : _b.long, meta: { touched: true, error: errors.position }, onChange: function (long) {
                                        return _this.setState({
                                            position: __assign(__assign({}, _this.state.position), { long: parseInt(long, 10) }),
                                        });
                                    } }),
                                " ")))),
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(Link, { to: "/devices", className: "white btn-flat left red-text" }, "Cancel"),
                        React.createElement("button", { className: "teal right btn btn-flat white-text", onClick: function () { return _this.handleFormSubmit(); }, disabled: keys(errors).length > 0 }, "Update Device"),
                        React.createElement("br", null),
                        React.createElement("br", null))))));
    };
    return EditDevice;
}(Component));
export default withRouter(EditDevice);



//////////////////
// WEBPACK FOOTER
// ./src/components/devices/EditDevice.tsx
// module id = 1274
// module chunks = 0